var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col",class:{ disabled: _vm.disabled }},[_c('div',{staticClass:"col__fix-part"},[_vm._t("fix-part")],2),_vm._v(" "),_c('div',{staticClass:"col__fluid-part"},[_c('div',{staticClass:"col__fluid-part__container",class:{
        'is-max-height': _vm.isMaxHeight
      }},[_vm._t("fluid-part")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }